import L from "leaflet";
import gaurdImg from "../../../assets/images/gaurd.png"
import vehicleImg from "../../../assets/images/vehicle.png"
import userImg from "../../../assets/images/user.png"


export const createCustomIcon = (imageUrl, updatedAt,isGaurd) => {
  const timeDifference = Date.now() - updatedAt;

  // Define colors based on time difference
  let statusColor = "red"; // Default is red
  if (timeDifference <= 3600 * 1000) {
    statusColor = "green"; // Within 1 hour
  } else if (timeDifference <= 1.5 * 24 * 3600 * 1000) {
    statusColor = "orange"; // Within 1.5 days
  }

  return L.icon({
     iconUrl: `${isGaurd?gaurdImg:vehicleImg}`,
    iconSize: [40, 40],
    iconAnchor: [20, 40],
    popupAnchor: [1, -30],
  });
};
export const createVehicleIcon = () => {

  return L.icon({
     iconUrl: vehicleImg,
    iconSize: [40, 40],
    iconAnchor: [20, 40],
    popupAnchor: [1, -30],
  });
};

export function offsetDuplicateLocations(entities, offsetDistance = 0.002) {
  const coordMap = new Map();

  return entities.map((entity) => {
    const { latitude, longitude } = entity.currentLocation || {};
    if (latitude == null || longitude == null) return entity;

    const key = `${latitude.toFixed(6)}_${longitude.toFixed(6)}`;
    const count = coordMap.get(key) || 0;
    coordMap.set(key, count + 1);

    return {
      ...entity,
      currentLocation: {
        ...entity.currentLocation,
        latitude: latitude,
        longitude: longitude + offsetDistance * count, // horizontal shift only
      },
    };
  });
}

export function groupEntitiesByCoordinates(entities) {
  const grouped = new Map();

  entities.forEach((entity) => {
    const { latitude, longitude } = entity.currentLocation || {};
    if (!latitude || !longitude) return;

    const key = `${latitude.toFixed(6)}_${longitude.toFixed(6)}`;
    if (!grouped.has(key)) grouped.set(key, []);
    grouped.get(key).push(entity);
  });

  return Array.from(grouped.entries()).map(([key, group]) => {
    const [lat, lng] = key.split("_").map(Number);
    return { lat, lng, entities: group };
  });
}

export function haversineDistance(lat1, lon1, lat2, lon2) {
  const R = 6371e3; // Earth radius in meters
  const toRad = (deg) => (deg * Math.PI) / 180;

  const φ1 = toRad(lat1);
  const φ2 = toRad(lat2);
  const Δφ = toRad(lat2 - lat1);
  const Δλ = toRad(lon2 - lon1);

  const a =
    Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) *
    Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c; // in meters
}

export function groupNearbyLocations(entities, thresholdInMeters = 80) {
  const groups = [];

  entities.forEach((entity) => {
    const loc = entity.currentLocation;
    if (!loc || loc.latitude == null || loc.longitude == null) return;

    const matchGroup = groups.find(group =>
      haversineDistance(loc.latitude, loc.longitude, group.lat, group.lng) <= thresholdInMeters
    );

    if (matchGroup) {
      matchGroup.entities.push(entity);
    } else {
      groups.push({
        lat: loc.latitude,
        lng: loc.longitude,
        entities: [entity],
      });
    }
  });

  return groups;
}



export const profileCustomIcon = (imageUrl) => {
  const defaultImageUrl = "https://cdn-icons-png.flaticon.com/512/149/149071.png"; // Default avatar image
  return L.icon({
     iconUrl: `${imageUrl?`${process.env.REACT_APP_ASSETURL}/${imageUrl}`:defaultImageUrl}`,
    iconSize: [30, 30],
    iconAnchor: [20, 40],
    popupAnchor: [1, -30],
  });
};

export  const profileIcon = (profilePic) => {
  const defaultImageUrl = "https://cdn-icons-png.flaticon.com/512/149/149071.png"; // Default avatar image

    const imageUrl = profilePic 
      ? `${process.env.REACT_APP_ASSETURL}/${profilePic}` 
      : defaultImageUrl;

    return L.divIcon({
      className: 'custom-marker',
      html: `<div style="
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: 2px solid #fff;
        box-shadow: 0 0 4px rgba(0,0,0,0.3);
        overflow: hidden;
        z-index: 900;
      ">
        <img src="${imageUrl}" 
        onerror="this.onerror=null; this.src='${defaultImageUrl}';"
        style="width: 100%; height: 100%; object-fit: cover;" />
      </div>`,
      iconSize: [40, 40],
      iconAnchor: [20, 20],
      popupAnchor: [0, -20]
    });
  };